import { render, staticRenderFns } from "./BlackHoleChargingSliders.vue?vue&type=template&id=c72692d6&scoped=true"
import script from "./BlackHoleChargingSliders.vue?vue&type=script&lang=js"
export * from "./BlackHoleChargingSliders.vue?vue&type=script&lang=js"
import style0 from "./BlackHoleChargingSliders.vue?vue&type=style&index=0&id=c72692d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72692d6",
  null
  
)

export default component.exports